import { render, staticRenderFns } from "./HorizontalRuler.vue?vue&type=template&id=72cb6308&scoped=true"
import script from "./HorizontalRuler.vue?vue&type=script&lang=js"
export * from "./HorizontalRuler.vue?vue&type=script&lang=js"
import style0 from "./HorizontalRuler.vue?vue&type=style&index=0&id=72cb6308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb6308",
  null
  
)

export default component.exports